// A phone browser pauses every <audio> and <video> on the page when a phone
// call comes in, and does not always play them again once the call is
// dismissed, so the others look frozen and go quiet until a rejoin (QUEUE
// row 329). This plays an element again whenever the page comes back in
// front, or it was paused while the page was in front.

export function keepPlaying(el: HTMLMediaElement): () => void {
  let retry: ReturnType<typeof setTimeout> | null = null;
  const resume = (): void => {
    if (retry) {
      clearTimeout(retry);
      retry = null;
    }
    if (document.visibilityState === "hidden" || !el.srcObject || !el.paused) return;
    void el.play().catch(() => {
      // Still held by the call, or waiting for a tap; the next return to
      // the page tries again.
    });
  };
  const onVisible = (): void => {
    if (document.visibilityState === "visible") resume();
  };
  // A pause the page did not ask for (an interruption) is followed up a
  // moment later, once the browser has settled.
  const onPause = (): void => {
    if (retry) clearTimeout(retry);
    retry = setTimeout(resume, 1000);
  };
  document.addEventListener("visibilitychange", onVisible);
  window.addEventListener("pageshow", resume);
  window.addEventListener("focus", resume);
  el.addEventListener("pause", onPause);
  return () => {
    if (retry) clearTimeout(retry);
    document.removeEventListener("visibilitychange", onVisible);
    window.removeEventListener("pageshow", resume);
    window.removeEventListener("focus", resume);
    el.removeEventListener("pause", onPause);
  };
}
